import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'courier'],

    data() {
        return {
            title: '',
            isLoading: false,
            freeDays: '',
            hasError: '',
            selectedDriver: null,
            model: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
            }
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.selectedDriver = this.courier
                this.title = this.selectedDriver.lastName
                this.model.monday = checkNullString(this.selectedDriver.freeDays).includes("Ponedeljak")
                this.model.tuesday = checkNullString(this.selectedDriver.freeDays).includes("Utorak")
                this.model.wednesday = checkNullString(this.selectedDriver.freeDays).includes("Sreda")
                this.model.thursday = checkNullString(this.selectedDriver.freeDays).includes("Četvrtak")
                this.model.friday = checkNullString(this.selectedDriver.freeDays).includes("Petak")
                this.model.saturday = checkNullString(this.selectedDriver.freeDays).includes("Subota")
                this.model.sunday = checkNullString(this.selectedDriver.freeDays).includes("Nedelja")
            }
        },
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeAddFreeDays')
            this.reset();
        },
        successUpdate(){
            this.$topnavbar.$emit('successAddFreeDays')
        },

        addFreeDays: addFreeDays,
        checkNullString: checkNullString,
        reset: reset,
    }
}

function addFreeDays() {
    let _self = this;
    var freeDays = ''
    if(_self.model.monday) freeDays+='Ponedeljak;';
    if(_self.model.tuesday) freeDays+='Utorak;';
    if(_self.model.wednesday) freeDays+='Sreda;';
    if(_self.model.thursday) freeDays+='Četvrtak;';
    if(_self.model.friday) freeDays+='Petak;';
    if(_self.model.saturday) freeDays+='Subota;';
    if(_self.model.sunday) freeDays+='Nedelja;';
    let newModel = {
        freeDays: freeDays
    }
    _self.isLoading = true;
    AdminApiService.updateFreeDays(newModel, _self.selectedDriver.id)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom dodavanja."
        })

}

function reset() {
    this.freeDays = '';
}


function checkNullString(data) {
    if(data == null) return '';
    return data;
}


// WEBPACK FOOTER //
// ./src/modals/AddCourierFreeDay.js